(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5638],{

/***/ 40076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76350);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var WrappedButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({}, props, {
        ref: ref
    }));
});
WrappedButton.displayName = "WrappedButton";
/* harmony default export */ __webpack_exports__["Z"] = (WrappedButton);


/***/ }),

/***/ 55638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FullImageWithMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40076);
/* harmony import */ var _helpers_misc_getFileURL__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2381);
/* harmony import */ var _helpers_misc_nl2br__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31503);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16492);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);







var renderImage = function renderImage(image, alt) {
    if (!image) return;
    var url = (0,_helpers_misc_getFileURL__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(image);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().imgContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().image),
            src: url,
            alt: alt,
            title: alt
        })
    });
};
function FullImageWithMessage(param) {
    var image = param.image, title = param.title, text = param.text, rightImage = param.rightImage, url = param.url, buttonText = param.buttonText;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: rightImage ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().containerRight) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: [
            renderImage(image, title),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().textBox),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().boxInner),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().title),
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().text),
                            children: (0,_helpers_misc_nl2br__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(text)
                        }),
                        url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: function() {
                                return router.push(url);
                            },
                            primary: true,
                            children: buttonText
                        }) : null
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 2381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GetFileURL; }
/* harmony export */ });
/**
 *
 * WARNING
 * this function will return an s3 file.
 * use a URL that goes through CloudFront (CDN) if possible.
 */ function GetFileURL(file) {
    if (!file) return;
    return "https://s3.amazonaws.com/".concat(file.bucket, "/").concat(file.key.replace(/ /g, "%20"));
};


/***/ }),

/***/ 31503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Nl2br; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Nl2br(text) {
    return text.split("\n").map(function(line, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                line,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        }, index);
    });
};


/***/ }),

/***/ 16492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"bDfm4qmkKZuBkFf6G0j65","containerRight":"_13WF5bqZawDlOP6bjU_1tv bDfm4qmkKZuBkFf6G0j65","imgContainer":"_33V9V28Yir7NjDCuIC2jTK","image":"CDQI_RMvUtFALAenRRfw7","textBox":"_2EOWR2W3HIHWfeoxeSchNF","boxInner":"IXe7P6mTigLFexru5onmU","title":"MDHe29CBVrt8dLIPn9kzn appSubtitle","text":"_1H7tOtefEGrpsHwvnJ7_kk"};

/***/ })

}]);